AlgoliaSearch.prototype.changeIndex = function(indexName) {
    this.indexName = indexName;
    this.search.indexName = this.indexName;
}

AlgoliaSearch.prototype.init = function() {
    this.search = instantsearch({
        appId: this.appId,
        apiKey: this.apiKey,
        indexName: this.indexName,
        urlSync: true
    });
    this.initSearch();
    this.initFacets();
}

AlgoliaSearch.prototype.initFacets = function() {
    this
        .getCaracteristics()
        .then(jQuery.proxy(this.getAttributesForFaceting, this), jQuery.proxy(this.startSearch,this))
        .then(jQuery.proxy(this.showFacets,this))
        .then(jQuery.proxy(this.startSearch,this))
    ;
}


AlgoliaSearch.prototype.startSearch = function() {
    this.search.addWidget(
        instantsearch.widgets.hierarchicalMenu({
            container: '#categories',
            attributes: [
                'categories.fr.TREE_0',
                'categories.fr.TREE_1',
                'categories.fr.TREE_2',
                'categories.fr.TREE_3',
                'categories.fr.TREE_4',
                'categories.fr.TREE_5',
                'categories.fr.TREE_6',
                'categories.fr.TREE_7'
            ],
            sortBy: ['name:asc'],
            limit: 200,
            cssClasses: {
              active: 'categorieSelected'
            },
            templates: {
              item: this.menuTemplate
            },
            showParentLevel: true,
            autoHideContainer: false,
            separator: ' > ',
            transformData: function(str) {
                var max = 20;
                var sep = '...';
                var seplen = 3;

                var len = str.length;
                if(len > max){
                    if(seplen > max) { return str.substr(len - max) }

                    var n = -0.5 * (max - len - seplen);
                    var center = len/2;
                    return str.substr(0, center - n) + sep + str.substr(len - center + n);
                }
                return str;
            }
        })
    );
  
    this.search.start();
}

AlgoliaSearch.prototype.showFacets = function(facets) {
    var pattern = 'caracteristics.fr.';
    for (var i = 0; i < facets.length; i++) {
        var facet = facets[i];
        if (facet.indexOf(pattern) > -1) {
            var id = facet.replace(/\./g,'_');
            var title = this.caracteristics[facet.replace(pattern,'')].name
            var newDiv = '<div id="'+id+'" class="facetFilter filtre"></div>';
            var sortBy = ['count:desc'];
            if (id === 'caracteristics_fr_29' || id === 'caracteristics_fr_34'){
              sortBy =['name:asc'];
            }

            $('#priceChoice').before($(newDiv));

            this.search.addWidget(
                instantsearch.widgets.refinementList({
                    container: '#'+id,
                    attributeName: facet,
                    operator: 'or',
                    limit: 100,
                    sortBy: sortBy,
                    cssClasses: {
                        active: 'active'
                    },
                    templates: {
                        item: this.facetTemplateCheckbox,
                        header: '<div class="titre checkboxs">'+
                                '  <div><h3>'+title+'</h3></div>'+
                                '  <div class="ferme">&nbsp;</div><div class="ouvert">&nbsp;</div>'+
                                '</div>'
                    },
                    collapsible: {collapsed: true}
                })
            );
        }
    }
}

AlgoliaSearch.prototype.initHit = function () {

    var mode = this.getURLParameter('display');

    if (mode != 'Small' && mode != 'Medium' && mode != 'Big') {
        mode = 'Medium';
    }

    var link = $('.displayMode[data-mode="'+mode+'"]');
    link.addClass('active');

    $('#resultsContainer').removeClass();
    $('#resultsContainer').addClass(link.attr('data-class'));

    var that = this;

    this.search.addWidget(
        instantsearch.widgets.hits({
            container: '#resultsContainer',
            hitsPerPage: 30,
            templates: {
                empty: that.noResultsTemplate,
                item: that['hitTemplate'+mode]
            },
            transformData: function(hit) {
                try {
                    var avers = hit.images[Object.keys(hit.images)[0]];

                    hit.avers = false;
                    if (avers !== null && typeof avers === 'object') {
                        hit.avers = avers.name;
                        hit.avers_medium = avers.name.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '');
                        hit.avers_big = avers.name.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
                    }
                } catch (e) {
                    hit.avers = false;
                }

                try {
                    var revers = hit.images[Object.keys(hit.images)[1]];

                    hit.revers = false;
                    if (revers !== null && typeof revers === 'object') {
                        hit.revers = revers.name;
                        hit.revers_medium = revers.name.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '');
                        hit.revers_big = revers.name.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
                    }
                } catch (e) {
                    hit.revers = false;
                }

              var tags = $('#tagsContainer').html();
                if (typeof hit.caracteristics !== 'undefined' && typeof hit.caracteristics.fr !== 'undefined') {
                    // quality
                    if (hit.caracteristics.fr[37]) { // for coins
                        hit.quality = hit.caracteristics.fr[37];
                    } else if (hit.caracteristics.fr[30]) { // for banknotes
                        hit.quality = hit.caracteristics.fr[30];
                    } else if (hit.caracteristics.fr[208]) { // for medals
                        hit.quality = hit.caracteristics.fr[208];
                    } else {
                        hit.quality = false;
                    }

                    // year
                    if (hit.caracteristics.fr[29]) {
                        hit.year = hit.caracteristics.fr[29];
                    } else {
                        hit.year = false;
                    }

                    // denomination
                    if (hit.caracteristics.fr[6]) {
                        hit.denomination = hit.caracteristics.fr[6];
                    } else {
                        hit.denomination = false;
                    }

                    // grading
                    if (hit.caracteristics.fr[65]) {
                        hit.grading = hit.caracteristics.fr[65];

                        if (hit.caracteristics.fr[92]) {
                            hit.grading = hit.grading+' '+hit.caracteristics.fr[92];
                        }
                    } else {
                        hit.grading = false;
                    }

                    // mintname
                    if (hit.caracteristics.fr[42]) {
                        hit.composition = hit.caracteristics.fr[42];
                    } else {
                        hit.composition = false;
                    }

                    // composition
                    if (hit.caracteristics.fr[39]) {
                        hit.mintname = hit.caracteristics.fr[39];
                    } else {
                        hit.mintname = false;
                    }
                }

              if (typeof hit.translations !== 'undefined') {             
                hit.title = hit.translations.fr.title;
                hit.category = hit.collections.leaf;
                hit.categoryName = hit.categories.fr['path'];

                if (tags.indexOf(hit.handle) > -1) {
                    hit.wished = true;
                } else {
                    hit.wished = false;
                }

                that.products[hit.reference] = hit;
              
              }
              //@todo remove this !
              if (hit.shopify) {
              	hit.handle = hit.shopify.fr.HANDLE;
              	hit.variant = hit.shopify.fr.VARIANT;
              }

                return hit;
            }
        })
    );
}

AlgoliaSearch.prototype.initSearch = function () {
    this.search.addWidget(
        instantsearch.widgets.searchBox({
            container: '#searchInput',
            wrapInput: false,
    		queryHook: window.debounce(function(query, search) {
        		search(query);
    		}, 1000)
            //searchOnEnterKeyPressOnly: true
        })
    );

    var bouton = {
      init: function(params) {
        $('#link2').click(function() {
          params.helper.setQuery($('#searchInput').val());
          params.helper.search();
        });
      }
    }
/*
    var debounce = {
      init: function(params) {
        var typingTimer = null;
        $('#searchInput').keyup(function() {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(function(){
                params.helper.setQuery($('#searchInput').val());
                params.helper.search();
            }, 1000);
        });
      }
    }

    this.search.addWidget(debounce);
*/

    this.search.addWidget(bouton);

    this.search.addWidget(
        instantsearch.widgets.pagination({
            container: '#pagination',
            cssClasses: {
                active: 'active',
                root: 'text-center',
            },
            labels: {
              previous: '<img src="//cdn.shopify.com/s/files/1/0985/6174/t/4/assets/back.png?v=24732072399643275921479471813" alt="<" class="back" /><span>'+$('#pagination').attr('data-previous')+'</span>',
              next: '<span>'+$('#pagination').attr('data-next')+'</span><img src="//cdn.shopify.com/s/files/1/0985/6174/t/4/assets/next.png?v=105805618336555293601479471843" alt="<" class="next" />'
            },
            showFirstLast: false
        })
    );

    this.search.addWidget(
        instantsearch.widgets.hitsPerPageSelector({
            container: '#perPageSelector',
            options: [
                {value: 30, label: '30 per page'},
                {value: 60, label: '60 per page'},
                {value: 90, label: '90 per page'}
            ],
            cssClasses: {
                root: 'prettySelect'
            }
        })
    );

    this.search.addWidget(
        instantsearch.widgets.stats({
            container: '#stats',
            templates: {
              body: '<strong>{{nbHits}}</strong> '+$('#stats').attr('data-text')+'</div>'
            }
        })
    );

    this.search.addWidget(
        instantsearch.widgets.priceRanges({
            container: '#priceChoice',
            attributeName: 'price',
            currency: '€',
            labels: {
              separator: 'to',
                button: 'Filter'
            },
            cssClasses: {
                list: 'nav nav-list',
                count: 'badge pull-right',
                active: 'active'
            },
            autoHideContainer: false,
            templates: {
              header: '<div class="titre checkboxs">'+
                '  <div><h3>'+$('#priceChoice').attr('data-title')+'</h3></div>'+
                '  <div class="ferme">&nbsp;</div><div class="ouvert">&nbsp;</div>'+
                '</div>'
            },
            collapsible: {collapsed: true}
        })
    );

    this.search.addWidget(
        instantsearch.widgets.sortBySelector({
            container: '#sortBy',
            indices: [
                {name: 'products_custom', label: $('#sortBy').attr('data-custom')},
                {name: 'products_en', label: $('#sortBy').attr('data-en')},
                {name: 'products_price_asc', label: $('#sortBy').attr('data-priceasc')},
                {name: 'products_price_desc', label: $('#sortBy').attr('data-pricedesc')}
            ],
            cssClasses: {
                root: 'prettySelect'
            }
        })
    );

    this.search.addWidget(
        instantsearch.widgets.toggle({
            container: '#isSold',
            attributeName: 'isSold',
            label: $('#isSold').attr('data-text'),
            autoHideContainer: false,
            values: {
                on: true,
                off: false
            },
            cssClasses: {
                count: 'hide',
            }
        })
    );

    this.search.addWidget(
      instantsearch.widgets.currentRefinedValues({
        clearAll: false,
        container: '#current-refined-values',
        cssClasses: {
            item: 'item',
            link: 'css-label',
        },
        templates: {
            item: function(data) {
              console.log(data)
                if (data.type !== "facet" && data.name != 'true' && data.name != 'false' && data.type !== "numeric") {
                    return  '<div class="filter-listed">'+
                    '<input class="css-checkbox" name="checkbox_'+data.attributeName+'" checked="checked" type="checkbox">'+
                        '<label class="css-label" for="checkbox_'+data.attributeName+'">'+data.name+'</label>'+
                      '</div>';
                } else if (data.type == "numeric") {                  
                    return  '<div class="filter-listed-num">'+
                    '<input class="css-checkbox" name="checkbox_'+data.attributeName+'" checked="checked" type="checkbox">'+
                        '<label class="css-label" for="checkbox_'+data.attributeName+'">'+
                      		''+data.displayOperator+' <span data-replace="price" class="changeCurrency" data-currency-eur="€'+data.name+'" data-currency="EUR">€'+data.name+'</span>'+
                      '</label>'+
                      '</div>';
                }
            },
        },
      })
    );

    this.initHit();
}

AlgoliaSearch.prototype.getAttributesForFaceting = function() {
    var dfd = jQuery.Deferred();
    var that = this;
    var client = algoliasearch(this.appId, this.apiKey);
    var index = client.initIndex(this.indexName);
    index.getSettings(function(err, content) {
        that.attributesForFaceting = content.attributesForFaceting;
        dfd.resolve(that.attributesForFaceting);
    });
    return dfd.promise();
}

AlgoliaSearch.prototype.getCaracteristics = function() {
    var that = this;
    var dfd = jQuery.Deferred();
    if (this.caracteristics == null) {
        $.ajax({
            url:  'https://placedesmonnaies.com/api/caracteristics?locale=fr',
            dataType: 'JSON',
        }).done(function(response) {
            that.caracteristics = response;
            dfd.resolve(that.caracteristics);
        }).fail(function(response) {
            dfd.reject();
        });
    }

    return dfd.promise();
}

AlgoliaSearch.prototype.getURLParameter = function(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++)
    {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam)
        {
            return sParameterName[1];
        }
    }
}


AlgoliaSearch.prototype.toggleElements = function() {
    var that = this;
  
    setTimeout(function() {
        $('[data-show]').each(function(){
            try{
                var display = eval($(this).attr('data-show'));
            } catch(e) {
                var display = true;
            }
            // display if "true" or anything else. Don't display if "false"
            if (display) {
                $(this).show();
            }
        });

        $('[data-hide]').each(function(){
            try{
                var display = eval($(this).attr('data-hide'));
            } catch(e) {
                var display = true;
            }
            // hide if "true" or anything else. Don't hide if "false"
            if (display) {
                $(this).hide();
            }
        });

        var tags = $('#tagsContainer').html();
        $('[data-wish]').each(function(){
            if (typeof AlgoliaSearchInstance.products[$(this).attr('data-ref')] === 'undefined') {
                return;
            }

            var handle = AlgoliaSearchInstance.products[$(this).attr('data-ref')]['handle'];
            $(this).attr('value', 'WISH|'+handle);

        });

        $('.alerttag').each(function(){
            var handle = $(this).val();

            if (tags.indexOf(handle) > -1) {
                $(this).parent().find('.alert-image').addClass('disabled');
            } else {
                $(this).parent().find('.alert-image').removeClass('disabled');
            }
        });

        $('img.lazy').each(function(){
            $(this).attr('src', $(this).attr('data-original'));
        });

        changeCurrency();
    }, 700);
}

var AlgoliaSearchInstance = new AlgoliaSearch();
AlgoliaSearchInstance.init();

$(document).ready(function(){

    $('body').on('click', '.changeImage', function(e) {
        e.preventDefault();
        
        $('.changeImage').removeClass('active');
        $(this).addClass('active');
      
        $('#imageDisplayMode').html($(this).html());

        if ($('.displayMode.active').attr('data-mode') != 'Big') {
            $('.avers').toggle();
            $('.revers').toggle();
        }
    });

    $('body').on('mouseover', '.produit:not(.big) .piece', function(e) {
        $(this).find('.avers').toggle();
        $(this).find('.revers').toggle();
    });

    $('body').on('mouseout', '.produit:not(.big) .piece', function(e) {
        $(this).find('.avers').toggle();
        $(this).find('.revers').toggle();
    });

    $('body').on('click', '.displayMode', function(e) {
        e.preventDefault();

        var uri = window.location.search;
        var key = 'display';
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            window.location.href = uri.replace(re, '$1' + key + "=" + $(this).attr('data-mode') + '$2');
        } else {
            window.location.href = uri + separator + key + "=" + $(this).attr('data-mode');
        }
    });

    $('#zoomHit').on('show.bs.modal', function (e) {
        var product = AlgoliaSearchInstance.products[e.relatedTarget.attributes['data-ref']['value']];
		//console.log(eval(product.shopify.en.VARIANT));
        $('#zoomHit [data-replace]').each(function(){
            $(this).html(product[$(this).attr('data-replace')]);
        });

        $('#zoomHit [data-src]').each(function(){
            $(this).attr('src', product[$(this).attr('data-src')]);
        });

        $('#zoomHit [data-link]').each(function(){
            $(this).attr('href', $(this).attr('data-link')+product['handle']);
        });

        $('#zoomHit [data-variant]').each(function(){
            $(this).attr($(this).attr('data-variant'), product['variant']);
        });

        $('#zoomHit [data-price]').each(function(){
            var price = product['price']+' €';
            $(this).html(price);
            $(this).attr('data-currency-eur', price);
            $(this).attr('data-currency', 'EUR');
            $(this).removeAttr('data-currency-usd');
            $(this).removeAttr('data-currency-gbp');
            $(this).removeAttr('data-currency-aud');
        });
        //changeCurrency();

        $('#zoomHit [data-show]').each(function(){
            try{
                var display = eval(product[$(this).attr('data-show')]);
            } catch(e) {
                var display = true;
            }
            // display if "true" or anything else. Don't display if "false"
            if (!display) {
                $(this).hide();
            } else {
                $(this).show();
            }
        });

        $('#zoomHit [data-wish]').each(function(){
            $(this).attr('value', 'WISH|'+product['handle'])
        });

        if ($(this).find('#error.nocustomer').length > 0) {
            $(this).find('#contactFormWrapper').hide();
            $(this).find('#success').hide();
            $(this).find('#error').show();
        } else {
            $(this).find('#contactFormWrapper').show();
            $(this).find('#success').hide();
        }

        if (e.relatedTarget.attributes['data-sold']['value'] == 'true') {
            $('#zoomHit #add-item-form').hide();
        } else {
            $('#zoomHit #add-item-form').show();
        }

        changeCurrency();
    });

    $('#zoomHit').on('click', '.miniature img', function(){
        $('#image-produit img').attr('src', $(this).attr('src'));
    });

    $('#alertModal').on('show.bs.modal', function (e) {
       var parent = e.relatedTarget.parentElement;

        $('#alertModal #variant').val(parent.children.variant.value);
        $('#alertModal #createtag').val(parent.children.createtag.value);

        if ($(parent).find('.alert-image').hasClass('disabled')) {
            $('#alertModal .alertsubscribed').show();
            $('#alertModal .input-group').hide();

            var link = $('#alertModal .collectionlink');
            link.attr('href',link.attr('href')+$(e.relatedTarget).attr('data-collection'));
            link.html($(e.relatedTarget).attr('data-category'));
        } else {
            $('#alertModal .alertsubscribed').hide();
            $('#alertModal .input-group').show();
        }
    });

    $('#alertModal').on('hidden.bs.modal', function (e) {
      $('#alertModal .input-group').show();
      $('#alert-success').hide();
    });

    $('body').on('click', '.displayMode, .ais-price-ranges--link, .facet-item, .ais-refinement-list--item .css-label, .ais-toggle--checkbox, .ais-pagination--item, #reset, #current-refined-values button', function(){
        AlgoliaSearchInstance.toggleElements();
    });

    $('body').on('change', '.ais-hits-per-page-selector, .ais-sort-by-selector', function(){
        AlgoliaSearchInstance.toggleElements();
    });
  
    /*$('body').on('change', '.ais-hits-per-page-selector', function(){
        setTimeout(function() {
          console.log($('.changeImage.active').attr('rel'));console.log($('.changeImage:not(.active)').attr('rel'));
            $($('.changeImage.active').attr('rel')).show();
            $($('.changeImage:not(.active)').attr('rel')).hide();
        }, 800);
    });*/
/*
    var typingTimer = null;
    $('body').on('keyup', '#searchInput', function(){
        clearTimeout(typingTimer);
        
        typingTimer = setTimeout(function(){
            var e = $.Event('keyup');
            e.keyCode = 13;
            $('#searchInput').trigger(e);
        }, 1000);              
    });
*/ 
    $('body').on('submit', 'form[action="/apps/wish"]', function(e) {
        e.preventDefault();
        var form = $(this);

        $('#spinnerOverlay, #spinner, #spinnerMessage').show();
        $.ajax({
            url: form.attr('action'),
            type: 'GET',
            data: form.serialize(),
            success: function(response) {
              $('#spinnerOverlay, #spinner, #spinnerMessage').hide();
              if (form.hasClass('little-form')) {
                $('#modalWishConfirm').modal('show');
                form.find('.wished').toggle();
                form.find('.notwished').toggle();
                form.find('#action').val('delete');
              } else {
                form.find('#contactFormWrapper').hide();
                form.find('#success').show();
              }
            },
            error: function(XMLHttpRequest) {
                $('#spinnerOverlay, #spinner, #spinnerMessage').hide();
                form.find('.wished').show();
                form.find('.notwished').hide();
                form.find('#action').val('create');
            }
        });
        return false;
    });

    $('body').on('submit', '#alertModal form', function(e) {
        e.preventDefault();
        var form = $(this);

        $('#spinnerOverlay, #spinner, #spinnerMessage').show();
        $.ajax({
            url: form.attr('action'),
            type: 'GET',
            data: form.serialize(),
            success: function(response) {
              form.parent().hide();
              $('#spinnerOverlay, #spinner, #spinnerMessage').hide();
              $('#alert-success').show();

              setTimeout(function(){$('#alertModal').modal('hide')}, 2500);
            },
            error: function(XMLHttpRequest) {
                $('#spinnerOverlay, #spinner, #spinnerMessage').hide();
            }
        });
        return false;
    });


    $('#saveSearchForm').on('submit', function(e) {
        e.preventDefault();
        var form = $(this);
        $(this).find('.ajaxerror').hide();

        if ($('#labelField').val() == '') {
            $(this).find('.error').show();
        } else {
            $(this).find('.error').hide();
            $('#urlField').val(btoa(window.location.href));
            $('#tagField').val('SEARCH|TITLE|'+$('#labelField').val()+'|LINK|'+$('#urlField').val());

            $('#spinnerOverlay, #spinner, #spinnerMessage').show();
            $.ajax({
                url: form.attr('action'),
                type: form.attr('method'),
                data: form.serialize(),
                success: function(response) {
                    var idsearch = $('#labelField').val()
                        .toString().toLowerCase()
                        .replace(/\s+/g, '-')
                        .replace(/[^\w\-]+/g, '')
                        .replace(/\-\-+/g, '-')
                        .replace(/^-+/, '')
                        .replace(/-+$/, '')
                    ;

                    var html= '<div class="row savedSearch">'+
                              '<h4 class="s-title">'+
                        	  '<img src="//cdn.shopify.com/s/files/1/0985/6174/t/4/assets/search.png?v=130638364403245810121479471853" alt="Saved Search" class="img-responsive">'+
                              $('#labelField').val()+
                              '</h4>'+
                              '<div class="remove-s-error"></div>'+
                              '<button class="s-view" onclick="document.location.href='+$('#urlField').val()+'">'+
                              '<img class="img-lien" src="//cdn.shopify.com/s/files/1/0985/6174/t/4/assets/next.png?v=105805618336555293601479471843" alt=">"> '+$('#labelField').attr('data-text')+'</button>'+
                              '<div class="remove">'+
                              '<form action="/apps/savesearch" method="GET" class="searched">'+
                              '<div id="contactFormWrapper">'+
                              '<input type="hidden" class="typeField" name="type" value="savesearch">'+
                              '<input type="hidden" class="idcField" name="idc" value="'+$('#customerField').val()+'">'+
                              '<input type="hidden" class="tagField" name="tag" value="'+response+'">'+
                              '<input type="hidden" class="actionField" name="action" value="delete">'+
                              '<input type="submit" class="cut" value="X">'+
                              '</div>'+
                              '</form>'+
                              '</div>'+
                              '</div>'
                    ;

                    $('.savemysearch .contenu .row').last().after($(html));
                    $('#labelField').val('');
                    $('#spinnerOverlay, #spinner, #spinnerMessage').hide();
                },
                error: function(XMLHttpRequest) {
                    $(this).find('.ajaxerror').show();
                    $('#spinnerOverlay, #spinner, #spinnerMessage').hide();
                }
            });
        }

        $('#urlField').val(window.location.href);
    });

    $('.savemysearch').on('submit', '.searched', function(e) {
        e.preventDefault();
        var form = $(this);

        if (form.find(".idcField").val() == "") {
            form.parents('.savedSearch').find('.remove-s-error').html($('#generalWarning').html());
            return false;
        }
        // type vide
        if (form.find(".typeField").val() == "") {
            form.parents('.savedSearch').find('.remove-s-error').html($('#wishlistError').html());
            return false;
        }
        // tag vide
        if (form.find(".tagField").val() == "") {
            form.parents('.savedSearch').find('.remove-s-error').html($('#wishlistError').html());
            return false;
        }
        // action vide
        if (form.find(".actionField").val()== "") {
            form.parents('.savedSearch').find('.remove-s-error').html($('#wishlistError').html());
            return false;
        }

        // Envoi Ajax
        e.preventDefault();
        $('#spinnerOverlay, #spinner, #spinnerMessage').show();
        $.ajax({
          type: form.attr('method'),
          url: form.attr('action'),
          data: form.serialize(),
          success: function(msg) {
              $('#removeSuccess').removeClass('hide');
              form.parents('.savedSearch').fadeOut();
              $('#spinnerOverlay, #spinner, #spinnerMessage').hide();
          },
          error: function(msg) {
              form.parents('.savedSearch').find('.remove-s-error').html($('#generalError').html());
              $('#spinnerOverlay, #spinner, #spinnerMessage').hide();
          }
        });
    });
});

$(window).load(function() {
    AlgoliaSearchInstance.toggleElements();
});